module.exports = __webpack_public_path__ + "static/media/rank-data-icon.c37f6b81.svg";